import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

// APIの住所を設定します。

const homeServices = (memberId: string): any => {
  return {
    getHome: () => apiClient.get(`${API_BASE_ADDRESS}/mypage/member/${memberId}/contract-information`),
  };
};

export default homeServices;
